import React, { Component } from 'react';
import styled from 'styled-components';
import ProjectIcon from './ProjectIcon';

class ProjectCard extends Component {

  constructor(props) {
    super(props);

    this.state = {
      activeTab: this.props.children[0].props.label,
      activeColor: this.props.children[0].props.color,
    };
  }

  onClickTabItem = (tab, color) => {
    this.setState({ activeTab: tab });
    this.setState({ activeColor: color });
  }

  render() {
    const {
      onClickTabItem,
      props: {
        children,
      },
      state: {
        activeTab,
        activeColor
      }
    } = this;

    const StyledContainer = styled.div`
      width: 100%;
      margin: 0 auto;
      h1 {
        color: ${activeColor};
      }
    `

    const StyledCard = styled.div`
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      width: 60%;
      min-height: 95vh;
      margin: 2.5vh auto;
      padding: 2rem 3.5rem;
      border-radius: .5rem;
      box-shadow: 0 2px 10px rgba(0,0,0,.1), 3px 5px 20px rgba(0,0,0,.3);
      background-color: #F7F7FF;
      transition: all .5s;
      @media (max-width: 43em) {
        width: 100%;
        margin: 0 auto;
        padding: 0 1.5rem;
        border-radius: 0;
      }
      @media (min-width: 43em) and (max-width: 62em) {
        min-height: 70vh;
        width: 100%;
        margin: 20% auto;
        padding: 0 1.5rem;
      }
    `

    const StyledTabs = styled.ol`
      display: flex;
      justify-content: space-around;
      position: absolute;
      left: 20%;
      bottom: 0;
      width: 60%;
      min-height: 10vh;
      @media (max-width: 43em) {
        position: relative;
        width: 100%;
        left: 0;
        min-height: 5vh;
      }
    `

    return (
      <StyledContainer>
        <StyledCard>
            {children.map((child) => {
              if (child.props.label !== activeTab) return undefined;
              return child.props.children;
            })}
        </StyledCard>
        <StyledTabs>
          {children.map((child) => {
            const { label, color } = child.props;

            return (
              <ProjectIcon
                activeTab={activeTab}
                activeColor={activeColor}
                key={label}
                label={label}
                color={color}
                onClick={onClickTabItem}
              />
            );
          })}
        </StyledTabs>
      </StyledContainer>
    )
  }
};

export default ProjectCard;